import difference from "lodash/difference";
import reduce from "lodash/reduce";

export const formatTempFilters = (tempFiltersToFormat, tempTab) => {
  const tempFiltersArray = Object.entries(tempFiltersToFormat);
  const formattedTempFilters = [];

  tempFiltersArray.forEach((group) => {
    if (tempTab.filterParams.includes(group[0])) {
      formattedTempFilters.push({
        queryParam: group[0],
        filters: group[1].sort(),
      });
    }
  });

  formattedTempFilters.sort((a, b) => {
    const paramsA = a.queryParam;
    const paramsB = b.queryParam;

    if (paramsA < paramsB) {
      return -1;
    } else {
      return 1;
    }
  });

  return formattedTempFilters;
};

export const updateAddedOrRemovedFilters = (filterGroups, prevFilterGroups) => {
  let addedFilters = [];
  let removedFilters = [];

  for (const groupType in filterGroups) {
    if (typeof filterGroups[groupType] === "string") {
      filterGroups[groupType] = [filterGroups[groupType]];
    }
  }
  for (const prevGroupType in prevFilterGroups) {
    if (typeof prevFilterGroups[prevGroupType] === "string") {
      prevFilterGroups[prevGroupType] = [prevFilterGroups[prevGroupType]];
    }
  }

  Object.keys(filterGroups).forEach((groupType) => {
    if (Object.keys(prevFilterGroups).includes(groupType)) {
      const newAddedValues = difference(
        filterGroups[groupType],
        prevFilterGroups[groupType]
      );
      addedFilters = addedFilters.concat(newAddedValues);

      const newRemovedValues = difference(
        prevFilterGroups[groupType],
        filterGroups[groupType]
      );
      removedFilters = removedFilters.concat(newRemovedValues);
    } else {
      addedFilters = addedFilters.concat(filterGroups[groupType]);
    }
  });

  Object.keys(prevFilterGroups).forEach((groupType) => {
    if (!Object.keys(filterGroups).includes(groupType)) {
      removedFilters = removedFilters.concat(prevFilterGroups[groupType]);
    }
  });

  return { addedFilters, removedFilters };
};

export const updateFiltersForCheckBox = (state, diff, tab) => {
  state.tabContents[tab].filterControls.groups.forEach((stateGroups) => {
    stateGroups.filters.forEach((groupFilter) => {
      if (diff.removedFilters.includes(groupFilter.label)) {
        groupFilter.isSelected = false;
      }
      if (diff.addedFilters.includes(groupFilter.label)) {
        groupFilter.isSelected = true;
      }
    });
  });
};

export const cleanQuery = (queryToClean) =>
  reduce(
    queryToClean,
    function (result, value, key) {
      if (key !== "q" && key !== "lang") {
        result[key] = value;
      }
      return result;
    },
    {}
  );
